import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=0b8203db&scoped=true&"
import script from "./ReportCard.vue?vue&type=script&lang=js&"
export * from "./ReportCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=0b8203db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8203db",
  null
  
)

export default component.exports